import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
// import api from '../../utils/api';
import axios from 'axios';
import { toast } from 'react-toastify';
import ConfirmationDialog from '../restaurants/ConfirmationDialog';
import Pagination from '../restaurants/Pagination';

import InvoiceDownload from '../subscription/InvoiceDownload';

import { formatSafeDate } from '../../utils/dateUtils';

// import { format } from 'date-fns';
// import LoadingSpinner from '../LoadingSpinner';

const PLAN_FEATURES = {
  free: ['5 messages per month', 'Basic features', 'Community support'],
  basic: [
    '100 messages per month',
    'Basic analytics',
    'Email support',
    'API access',
  ],
  pro: [
    'Unlimited messages',
    'Advanced analytics',
    'Priority support',
    'Custom branding',
    'Dedicated account manager',
  ],
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

const MembershipInfo = () => {
  // const { restaurantId } = useParams();
  const navigate = useNavigate();
  const [membershipData, setMembershipData] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [error, setError] = useState(null);
  const ITEMS_PER_PAGE = 10;

  const isPaidMembership = membershipData?.type !== 'free';

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const [membershipResponse, transactionsResponse] = await Promise.all([
        api.get('/subscriptions/current', {
          headers: { Authorization: `Bearer ${token}` },
        }),
        api.get('/subscriptions/transactions', {
          params: { page: 1, limit: 10 },
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setMembershipData(membershipResponse.data);
      setTransactions(transactionsResponse.data.transactions);
      setTotalPages(transactionsResponse.data.totalPages);
    } catch (error) {
      setError('Failed to fetch membership details');
      toast.error('Failed to fetch membership details');
    } finally {
      setLoading(false);
    }
  };

  const fetchTransactions = async (page) => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await api.get(`/subscriptions/transactions`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page,
          limit: ITEMS_PER_PAGE,
        },
      });
      setTransactions(response.data.transactions || []);
      setTotalPages(response.data.totalPages || 1);
      setCurrentPage(page);
    } catch (error) {
      toast.error('Failed to fetch transactions');
    }
  };

  const handleCancelMembership = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      await api.post(
        `/subscriptions/cancel`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success('Membership cancelled successfully');
      await fetchData();
    } catch (error) {
      toast.error('Failed to cancel membership');
    } finally {
      setShowCancelDialog(false);
    }
  };

  const handleUpgrade = () => {
    navigate(`/owner/membership`);
  };

  if (loading) {
    return (
      <div className='flex items-center justify-center min-h-screen'>
        <div className='w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin'></div>
      </div>
    );
  }

  // if (error) {
  //   return (
  //     <div className='p-4 text-center'>
  //       <p className='text-red-500'>{error}</p>
  //       <button
  //         onClick={fetchMembershipData}
  //         className='mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600'
  //       >
  //         Retry
  //       </button>
  //     </div>
  //   );
  // }

  return (
    <div className='container mx-auto px-4 py-8'>
      {/* Membership Status Banner */}
      {/* {membershipData?.status === 'cancelled' && (
        <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6'>
          <p>
            Your membership will end on{' '}
            {format(new Date(membershipData.endDate), 'MMMM dd, yyyy')}.
          </p>
        </div>
      )} */}
      {/* {isPaidMembership && membershipData?.cancelledAt && (
        <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6'>
          <p>
            Your membership will end on{' '}
            {format(new Date(membershipData.endDate), 'MMMM dd, yyyy')}.
          </p>
        </div>
      )} */}

      {/* {membershipData?.canceledAt && ( */}
      {membershipData?.canceledAt && membershipData?.currentPeriodEnd && (
        <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6'>
          <p>
            Your membership will end on{' '}
            {/* {format(new Date(membershipData.currentPeriodEnd), 'MMMM dd, yyyy')} */}
            {formatSafeDate(membershipData.currentPeriodEnd)}.
          </p>
        </div>
      )}

      {/* {membershipData?.pendingDowngrade && ( */}
      {membershipData?.pendingDowngrade?.effectiveDate && (
        <div className='bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-6'>
          <p>
            Your plan will change to {membershipData.pendingDowngrade.planId} on{' '}
            {/* {format(
              new Date(membershipData.pendingDowngrade.effectiveDate),
              'MMMM dd, yyyy'
            )} */}
            {formatSafeDate(membershipData.pendingDowngrade.effectiveDate)}.
          </p>
        </div>
      )}

      {/* Current Membership Info Section */}
      <div className='bg-white rounded-lg shadow-md p-6 mb-8'>
        <div className='flex justify-between items-center mb-6'>
          <h2 className='text-2xl font-bold'>Current Membership</h2>
          <div className='space-x-4'>
            <button
              onClick={handleUpgrade}
              className='bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600'
            >
              {membershipData?.type === 'free' ? 'Upgrade Plan' : 'Change Plan'}
            </button>
            {/* {membershipData?.status === 'active' &&
              !membershipData?.cancelledAt && (
                <button
                  onClick={() => setShowCancelDialog(true)}
                  className='bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600'
                >
                  Cancel Membership
                </button>
              )} */}
            {isPaidMembership && !membershipData?.cancelledAt && (
              <button
                onClick={() => setShowCancelDialog(true)}
                className='bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600 text-center'
              >
                Cancel Membership
              </button>
            )}
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
          <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Membership Type</p>
            <p className='font-semibold text-lg capitalize'>
              {/* {membershipData?.type || 'Free'} */}
              {membershipData?.type}
            </p>
          </div>

          <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Status</p>
            <div>
              <p
                className={`font-semibold text-lg capitalize ${
                  membershipData?.status === 'active'
                    ? 'text-green-600'
                    : 'text-red-600'
                }`}
              >
                {membershipData?.status || 'Inactive'}
              </p>
              {membershipData?.pendingDowngrade && (
                <p className='text-sm text-orange-500'>
                  Changing to {membershipData.pendingDowngrade.planId} on{' '}
                  {/* {format(
                    new Date(membershipData.pendingDowngrade.effectiveDate),
                    'MMM dd, yyyy'
                  )} */}
                  {formatSafeDate(
                    membershipData.pendingDowngrade.effectiveDate
                  )}
                </p>
              )}
            </div>
          </div>

          {/* <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Status</p>
            <p
              className={`font-semibold text-lg capitalize ${
                membershipData?.status === 'active'
                  ? 'text-green-600'
                  : 'text-red-600'
              }`}
            >
              {membershipData?.status || 'Inactive'}
            </p>
          </div> */}
          <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Credits Remaining</p>
            <p className='font-semibold text-lg'>
              {/* {membershipData?.credits || 0} */}
              {/* {membershipData?.credits || 'N/A'} */}
              {membershipData?.credits || 'N/A'}
            </p>
          </div>

          {/* <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Start Date</p>
            <p className='font-semibold text-lg'>
             
              {isPaidMembership && membershipData?.startDate
                ? format(new Date(membershipData.startDate), 'MMM dd, yyyy')
                : 'N/A'}
            </p>
          </div>
          <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Current Period Ends</p>
            <p className='font-semibold text-lg'>
            
              {isPaidMembership && membershipData?.endDate
                ? format(new Date(membershipData.endDate), 'MMM dd, yyyy')
                : 'N/A'}
            </p>
          </div>
          <div className='p-4 bg-gray-50 rounded-lg'>
            <p className='text-gray-600'>Next Payment</p>
            <p className='font-semibold text-lg'>
             
              {isPaidMembership && membershipData?.nextPaymentDate
                ? format(
                    new Date(membershipData.nextPaymentDate),
                    'MMM dd, yyyy'
                  )
                : 'N/A'}
            </p>
          </div> */}

          {isPaidMembership && (
            <>
              <div className='p-4 bg-gray-50 rounded-lg'>
                <p className='text-gray-600'>Start Date</p>
                <p className='font-semibold text-lg'>
                  {/* {format(
                    new Date(membershipData.currentPeriodStart),
                    'MMM dd, yyyy'
                  )} */}
                  {formatSafeDate(membershipData?.currentPeriodStart)}
                </p>
              </div>

              <div className='p-4 bg-gray-50 rounded-lg'>
                <p className='text-gray-600'>Current Period Ends</p>
                <p className='font-semibold text-lg'>
                  {/* {format(
                    new Date(membershipData.currentPeriodEnd),
                    'MMM dd, yyyy'
                  )} */}
                  {formatSafeDate(membershipData?.currentPeriodEnd)}
                </p>
              </div>

              <div className='p-4 bg-gray-50 rounded-lg'>
                <p className='text-gray-600'>Next Payment</p>
                <p className='font-semibold text-lg'>
                  {membershipData?.canceledAt
                    ? 'No upcoming payment'
                    : // : membershipData.upcomingInvoice
                    membershipData?.upcomingInvoice?.date
                    ? `$${(membershipData.upcomingInvoice.amount / 100).toFixed(
                        2
                      )} on ${
                        //   format(
                        //   new Date(membershipData.upcomingInvoice.date),
                        //   'MMM dd, yyyy'
                        // )
                        formatSafeDate(membershipData.upcomingInvoice.date)
                      }`
                    : 'N/A'}
                </p>
              </div>
            </>
          )}
        </div>

        {/* Membership Benefits Section */}
        <div className='mt-6 p-4 bg-blue-50 rounded-lg'>
          <h3 className='font-semibold mb-2'>Current Plan Features</h3>
          <ul className='list-disc list-inside space-y-1'>
            {/* {PLAN_FEATURES[membershipData?.type || 'free'].map(
              (feature, index) => (
                <li key={index}>{feature}</li>
              )
            )} */}
            {PLAN_FEATURES[membershipData?.type || 'free']?.map(
              (feature, index) => (
                <li key={index}>{feature}</li>
              )
            )}
          </ul>
        </div>
      </div>

      {/* Transaction History Section */}
      <div className='bg-white rounded-lg shadow-md p-6'>
        <h2 className='text-2xl font-bold mb-6'>Transaction History</h2>
        {transactions.length === 0 ? (
          <p className='text-gray-500 text-center py-8'>
            No transactions found
          </p>
        ) : (
          <>
            <div className='overflow-x-auto'>
              <table className='min-w-full'>
                <thead>
                  <tr className='bg-gray-50'>
                    <th className='px-6 py-3 text-left text-gray-500 font-medium'>
                      Date
                    </th>
                    <th className='px-6 py-3 text-left text-gray-500 font-medium'>
                      Description
                    </th>
                    <th className='px-6 py-3 text-left text-gray-500 font-medium'>
                      Amount
                    </th>
                    <th className='px-6 py-3 text-left text-gray-500 font-medium'>
                      Status
                    </th>
                    <th className='px-6 py-3 text-left text-gray-500 font-medium'>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction) => (
                    <tr
                      key={transaction.id}
                      className='border-t hover:bg-gray-50'
                    >
                      <td className='px-6 py-4'>
                        {/* {format(new Date(transaction.date), 'MMM dd, yyyy')} */}
                        {formatSafeDate(transaction.date)}
                      </td>
                      <td className='px-6 py-4'>
                        {transaction.description}
                        {transaction.type === 'downgrade' && (
                          <span className='ml-2 text-orange-500'>
                            (Changes effective{' '}
                            {/* {format(
                              new Date(transaction.effectiveDate),
                              'MMM dd, yyyy'
                            )} */}
                            {formatSafeDate(transaction.effectiveDate)})
                          </span>
                        )}
                      </td>
                      <td className='px-6 py-4'>
                        ${(transaction.amount / 100).toFixed(2)}
                      </td>
                      <td className='px-6 py-4'>
                        <span
                          className={`px-2 py-1 rounded-full text-sm ${
                            transaction.status === 'completed'
                              ? 'bg-green-100 text-green-800'
                              : 'bg-red-100 text-red-800'
                          }`}
                        >
                          {transaction.status}
                        </span>
                      </td>
                      <td className='px-6 py-4'>
                        <InvoiceDownload transactionId={transaction.id} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className='mt-6'>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={fetchTransactions}
                />
              </div>
            )}
          </>
        )}
      </div>

      <ConfirmationDialog
        isOpen={showCancelDialog}
        onClose={() => setShowCancelDialog(false)}
        onConfirm={handleCancelMembership}
        title='Cancel Membership'
        message='Are you sure you want to cancel your membership? This will take effect at the end of your current billing period.'
      />
    </div>
  );
};

export default MembershipInfo;

// import React, { useState, useEffect } from 'react';
// import { useParams, Link, useNavigate } from 'react-router-dom';
// // import api from '../../utils/api';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import ConfirmationDialog from '../restaurants/ConfirmationDialog';
// import Pagination from '../restaurants/Pagination';

// import { format } from 'date-fns';
// // import LoadingSpinner from '../LoadingSpinner';

// import InvoiceDownload from '../subscription/InvoiceDownload';

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   timeout: 5000,
// });

// const MembershipInfo = () => {
//   const { restaurantId } = useParams();
//   const navigate = useNavigate();
//   const [membershipData, setMembershipData] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [showCancelDialog, setShowCancelDialog] = useState(false);
//   const [error, setError] = useState(null);
//   const ITEMS_PER_PAGE = 10;

//   const isPaidMembership = membershipData?.type !== 'free';

//   useEffect(() => {
//     fetchMembershipData();
//     fetchTransactions(1);
//   }, [restaurantId]);

//   const fetchMembershipData = async () => {
//     try {
//       const token = localStorage.getItem('ownerToken');

//       const response = await api.get(
//         // `/api/restaurants/${restaurantId}/membership`
//         `/subscriptions/current`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       if (response.data) {
//         setMembershipData(response.data);
//       }
//       // else {
//       //   // Handle case where no membership exists
//       //   setMembershipData({
//       //     type: 'basic',
//       //     status: 'inactive',
//       //     credits: 0,
//       //     startDate: new Date(),
//       //     endDate: new Date(),
//       //     nextPaymentDate: new Date(),
//       //   });
//       // }
//       // else {
//       //   setMembershipData({
//       //     type: 'free',
//       //     credits: 5,
//       //   });
//       // }
//     } catch (error) {
//       setError('Failed to fetch membership details');
//       toast.error('Failed to fetch membership details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTransactions = async (page) => {
//     try {
//       const token = localStorage.getItem('ownerToken');

//       const response = await api.get(`/subscriptions/transactions`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page,
//           limit: ITEMS_PER_PAGE,
//         },
//       });
//       setTransactions(response.data.transactions || []);
//       setTotalPages(response.data.totalPages || 1);
//       setCurrentPage(page);
//     } catch (error) {
//       toast.error('Failed to fetch transactions');
//     }
//   };

//   const handleCancelMembership = async () => {
//     try {
//       const token = localStorage.getItem('ownerToken');

//       await api.post(`/subscriptions/cancel`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       toast.success('Membership cancelled successfully');
//       fetchMembershipData();
//     } catch (error) {
//       toast.error('Failed to cancel membership');
//     } finally {
//       setShowCancelDialog(false);
//     }
//   };

//   const handleUpgrade = () => {
//     navigate(`/subscriptions/upgrade`);
//   };

//   if (loading) {
//     return (
//       <div className='flex items-center justify-center min-h-screen'>
//         <div className='w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin'></div>
//       </div>
//     );
//   }

//   // if (error) {
//   //   return (
//   //     <div className='p-4 text-center'>
//   //       <p className='text-red-500'>{error}</p>
//   //       <button
//   //         onClick={fetchMembershipData}
//   //         className='mt-4 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600'
//   //       >
//   //         Retry
//   //       </button>
//   //     </div>
//   //   );
//   // }

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       {/* Membership Status Banner */}
//       {/* {membershipData?.status === 'cancelled' && (
//         <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6'>
//           <p>
//             Your membership will end on{' '}
//             {format(new Date(membershipData.endDate), 'MMMM dd, yyyy')}.
//           </p>
//         </div>
//       )} */}
//       {isPaidMembership && membershipData?.cancelledAt && (
//         <div className='bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6'>
//           <p>
//             Your membership will end on{' '}
//             {format(new Date(membershipData.endDate), 'MMMM dd, yyyy')}.
//           </p>
//         </div>
//       )}

//       {/* Current Membership Info Section */}
//       <div className='bg-white rounded-lg shadow-md p-6 mb-8'>
//         <div className='flex justify-between items-center mb-6'>
//           <h2 className='text-2xl font-bold'>Current Membership</h2>
//           <div className='space-x-4'>
//             <button
//               onClick={handleUpgrade}
//               className='bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600'
//             >
//               {membershipData?.type === 'free' ? 'Upgrade Plan' : 'Change Plan'}
//             </button>
//             {/* {membershipData?.status === 'active' &&
//               !membershipData?.cancelledAt && (
//                 <button
//                   onClick={() => setShowCancelDialog(true)}
//                   className='bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600'
//                 >
//                   Cancel Membership
//                 </button>
//               )} */}
//             {isPaidMembership && !membershipData?.cancelledAt && (
//               <button
//                 onClick={() => setShowCancelDialog(true)}
//                 className='bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600 text-center'
//               >
//                 Cancel Membership
//               </button>
//             )}
//           </div>
//         </div>

//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6'>
//           <div className='p-4 bg-gray-50 rounded-lg'>
//             <p className='text-gray-600'>Membership Type</p>
//             <p className='font-semibold text-lg capitalize'>
//               {/* {membershipData?.type || 'Free'} */}
//               {membershipData?.type}
//             </p>
//           </div>
//           {/* <div className='p-4 bg-gray-50 rounded-lg'>
//             <p className='text-gray-600'>Status</p>
//             <p
//               className={`font-semibold text-lg capitalize ${
//                 membershipData?.status === 'active'
//                   ? 'text-green-600'
//                   : 'text-red-600'
//               }`}
//             >
//               {membershipData?.status || 'Inactive'}
//             </p>
//           </div> */}
//           <div className='p-4 bg-gray-50 rounded-lg'>
//             <p className='text-gray-600'>Credits Remaining</p>
//             <p className='font-semibold text-lg'>
//               {/* {membershipData?.credits || 0} */}
//               {membershipData?.credits || 'N/A'}
//             </p>
//           </div>
//           <div className='p-4 bg-gray-50 rounded-lg'>
//             <p className='text-gray-600'>Start Date</p>
//             <p className='font-semibold text-lg'>
//               {/* {membershipData?.startDate
//                 ? format(new Date(membershipData.startDate), 'MMM dd, yyyy')
//                 : 'N/A'} */}
//               {isPaidMembership && membershipData?.startDate
//                 ? format(new Date(membershipData.startDate), 'MMM dd, yyyy')
//                 : 'N/A'}
//             </p>
//           </div>
//           <div className='p-4 bg-gray-50 rounded-lg'>
//             <p className='text-gray-600'>Current Period Ends</p>
//             <p className='font-semibold text-lg'>
//               {/* {membershipData?.endDate
//                 ? format(new Date(membershipData.endDate), 'MMM dd, yyyy')
//                 : 'N/A'} */}
//               {isPaidMembership && membershipData?.endDate
//                 ? format(new Date(membershipData.endDate), 'MMM dd, yyyy')
//                 : 'N/A'}
//             </p>
//           </div>
//           <div className='p-4 bg-gray-50 rounded-lg'>
//             <p className='text-gray-600'>Next Payment</p>
//             <p className='font-semibold text-lg'>
//               {/* {membershipData?.nextPaymentDate
//                 ? format(
//                     new Date(membershipData.nextPaymentDate),
//                     'MMM dd, yyyy'
//                   )
//                 : 'N/A'} */}
//               {isPaidMembership && membershipData?.nextPaymentDate
//                 ? format(
//                     new Date(membershipData.nextPaymentDate),
//                     'MMM dd, yyyy'
//                   )
//                 : 'N/A'}
//             </p>
//           </div>
//         </div>

//         {/* Membership Benefits Section */}
//         <div className='mt-6 p-4 bg-blue-50 rounded-lg'>
//           <h3 className='font-semibold mb-2'>Current Plan Features</h3>
//           <ul className='list-disc list-inside space-y-1'>
//             {membershipData?.type === 'free' && (
//               <>
//                 <li>5 messages per month</li>
//                 <li>Basic features</li>
//                 <li>Community support</li>
//               </>
//             )}
//             {membershipData?.type === 'basic' && (
//               <>
//                 <li>100 messages per month</li>
//                 <li>Basic analytics</li>
//                 <li>Email support</li>
//               </>
//             )}
//             {membershipData?.type === 'pro' && (
//               <>
//                 <li>Unlimited messages</li>
//                 <li>Advanced analytics</li>
//                 <li>Priority support</li>
//                 <li>Custom branding</li>
//               </>
//             )}
//           </ul>
//         </div>
//       </div>

//       {/* Transaction History Section */}
//       <div className='bg-white rounded-lg shadow-md p-6'>
//         <h2 className='text-2xl font-bold mb-6'>Transaction History</h2>
//         {transactions.length === 0 ? (
//           <p className='text-gray-500 text-center py-8'>
//             No transactions found
//           </p>
//         ) : (
//           <>
//             <div className='overflow-x-auto'>
//               <table className='min-w-full'>
//                 <thead>
//                   <tr className='bg-gray-50'>
//                     <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                       Date
//                     </th>
//                     <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                       Description
//                     </th>
//                     <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                       Amount
//                     </th>
//                     <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                       Status
//                     </th>
//                     <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                       Invoice
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {transactions.map((transaction) => (
//                     <tr
//                       key={transaction._id}
//                       className='border-t hover:bg-gray-50'
//                     >
//                       <td className='px-6 py-4'>
//                         {format(new Date(transaction.date), 'MMM dd, yyyy')}
//                       </td>
//                       <td className='px-6 py-4'>{transaction.description}</td>
//                       <td className='px-6 py-4'>
//                         ${(transaction.amount / 100).toFixed(2)}
//                       </td>
//                       <td className='px-6 py-4'>
//                         <span
//                           className={`px-2 py-1 rounded-full text-sm ${
//                             transaction.status === 'completed'
//                               ? 'bg-green-100 text-green-800'
//                               : 'bg-red-100 text-red-800'
//                           }`}
//                         >
//                           {transaction.status}
//                         </span>
//                       </td>
//                       <td className='px-6 py-4'>
//                         {transaction.invoiceUrl ? (
//                           <a
//                             href={transaction.invoiceUrl}
//                             target='_blank'
//                             rel='noopener noreferrer'
//                             className='text-blue-500 hover:text-blue-700'
//                           >
//                             View Invoice
//                           </a>
//                         ) : (
//                           <span className='text-gray-400'>Not available</span>
//                         )}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {totalPages > 1 && (
//               <div className='mt-6'>
//                 <Pagination
//                   currentPage={currentPage}
//                   totalPages={totalPages}
//                   onPageChange={fetchTransactions}
//                 />
//               </div>
//             )}
//           </>
//         )}
//       </div>

//       <ConfirmationDialog
//         isOpen={showCancelDialog}
//         onClose={() => setShowCancelDialog(false)}
//         onConfirm={handleCancelMembership}
//         title='Cancel Membership'
//         message='Are you sure you want to cancel your membership? This will take effect at the end of your current billing period.'
//       />
//     </div>
//   );
// };

// export default MembershipInfo;

// const MembershipInfo = () => {

//   const [membership, setMembership] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const { restaurantId } = useParams();

//   useEffect(() => {
//     fetchMembershipData();
//     fetchTransactions(1);
//   }, []);

//   const fetchMembershipData = async () => {
//     try {
//       const response = await api.get(`/restaurants/${restaurantId}/membership`);
//       setMembership(response.data);
//     } catch (error) {
//       setError('Failed to fetch membership details');
//     }
//   };

//   const fetchTransactions = async (page) => {
//     try {
//       const response = await api.get(
//         `/restaurants/${restaurantId}/membership/transactions?page=${page}`
//       );
//       setTransactions(response.data.transactions);
//       setTotalPages(response.data.totalPages);
//       setCurrentPage(response.data.currentPage);
//     } catch (error) {
//       setError('Failed to fetch transactions');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleCancelMembership = async () => {
//     try {
//       await api.post(`/restaurants/${restaurantId}/membership/cancel`);
//       fetchMembershipData();
//     } catch (error) {
//       setError('Failed to cancel membership');
//     }
//   };

//   if (loading)
//     return (
//       <div className='flex items-center justify-center min-h-screen'>
//         <div className='w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin'></div>
//       </div>
//     );
//   // if (error) return <div className='text-red-500'>{error}</div>;

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <div className='bg-white rounded-lg shadow-md p-6 mb-8'>
//         <h2 className='text-2xl font-bold mb-6'>Membership Details</h2>
//         <div className='grid grid-cols-2 gap-6'>
//           <div>
//             <p className='text-gray-600'>Type</p>
//             <p className='font-semibold'>{membership?.type}</p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Status</p>
//             <p className='font-semibold'>{membership?.status}</p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Start Date</p>
//             <p className='font-semibold'>
//               {format(new Date(membership?.startDate), 'PP')}
//             </p>
//           </div>
//           <div>
//             <p className='text-gray-600'>End Date</p>
//             <p className='font-semibold'>
//               {format(new Date(membership?.endDate), 'PP')}
//             </p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Credits</p>
//             <p className='font-semibold'>{membership?.credits}</p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Next Payment</p>
//             <p className='font-semibold'>
//               {format(new Date(membership?.nextPaymentDate), 'PP')}
//             </p>
//           </div>
//         </div>

//         {membership?.status === 'active' && (
//           <button
//             onClick={handleCancelMembership}
//             className='mt-6 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600'
//           >
//             Cancel Membership
//           </button>
//         )}
//       </div>

//       <div className='bg-white rounded-lg shadow-md p-6'>
//         <h2 className='text-2xl font-bold mb-6'>Transaction History</h2>
//         <div className='overflow-x-auto'>
//           <table className='min-w-full'>
//             <thead>
//               <tr>
//                 <th className='px-6 py-3 text-left'>Date</th>
//                 <th className='px-6 py-3 text-left'>Description</th>
//                 <th className='px-6 py-3 text-left'>Amount</th>
//                 <th className='px-6 py-3 text-left'>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {transactions.map((transaction) => (
//                 <tr key={transaction._id}>
//                   <td className='px-6 py-4'>
//                     {format(new Date(transaction.date), 'PP')}
//                   </td>
//                   <td className='px-6 py-4'>{transaction.description}</td>
//                   <td className='px-6 py-4'>
//                     ${(transaction.amount / 100).toFixed(2)}
//                   </td>
//                   <td className='px-6 py-4'>
//                     <span
//                       className={`px-2 py-1 rounded-full text-sm ${
//                         transaction.status === 'completed'
//                           ? 'bg-green-100 text-green-800'
//                           : 'bg-red-100 text-red-800'
//                       }`}
//                     >
//                       {transaction.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {totalPages > 1 && (
//           <div className='mt-4 flex justify-center'>
//             <nav className='relative z-0 inline-flex rounded-md shadow-sm -space-x-px'>
//               {[...Array(totalPages)].map((_, i) => (
//                 <button
//                   key={i + 1}
//                   onClick={() => fetchTransactions(i + 1)}
//                   className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
//                     currentPage === i + 1
//                       ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600'
//                       : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
//                   }`}
//                 >
//                   {i + 1}
//                 </button>
//               ))}
//             </nav>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MembershipInfo;

// // components/membership/MembershipInfo.jsx
// import React, { useState, useEffect } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import axios from 'axios';
// import { format } from 'date-fns';
// import { FaSpinner } from 'react-icons/fa';
// import Pagination from '../restaurants/Pagination';
// import ConfirmationDialog from '../restaurants/ConfirmationDialog';
// import { ToastContainer, toast } from 'react-toastify';

// const MembershipInfo = () => {
//   const { restaurantId } = useParams();
//   const [membershipData, setMembershipData] = useState(null);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [showCancelDialog, setShowCancelDialog] = useState(false);
//   const ITEMS_PER_PAGE = 10;

//   useEffect(() => {
//     fetchMembershipData();
//     fetchTransactions(1);
//   }, []);

//   const fetchMembershipData = async () => {
//     try {
//       const response = await axios.get(`/api/memberships/${restaurantId}`);
//       setMembershipData(response.data);
//     } catch (error) {
//       toast.error('Failed to fetch membership details');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchTransactions = async (page) => {
//     try {
//       const response = await axios.get(
//         `/api/memberships/${restaurantId}/transactions?page=${page}&limit=${ITEMS_PER_PAGE}`
//       );
//       setTransactions(response.data.transactions);
//       setTotalPages(response.data.totalPages);
//       setCurrentPage(page);
//     } catch (error) {
//       toast.error('Failed to fetch transactions');
//     }
//   };

//   const handleCancelMembership = async () => {
//     try {
//       await axios.post(`/api/memberships/${restaurantId}/cancel`);
//       toast.success('Membership cancelled successfully');
//       fetchMembershipData();
//     } catch (error) {
//       toast.error('Failed to cancel membership');
//     }
//     setShowCancelDialog(false);
//   };

//   if (loading) {
//     return (
//       <FaSpinner className='animate-spin text-4xl text-blue-500 mx-auto' />
//     );
//   }

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       {/* Current Membership Info Section */}
//       <div className='bg-white rounded-lg shadow-md p-6 mb-8'>
//         <h2 className='text-2xl font-bold mb-6'>Current Membership</h2>
//         <div className='grid grid-cols-2 gap-6'>
//           <div>
//             <p className='text-gray-600'>Membership Type</p>
//             <p className='font-semibold'>{membershipData?.type}</p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Status</p>
//             <p className='font-semibold'>{membershipData?.status}</p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Start Date</p>
//             <p className='font-semibold'>
//               {format(new Date(membershipData?.startDate), 'MMM dd, yyyy')}
//             </p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Next Payment Date</p>
//             <p className='font-semibold'>
//               {format(
//                 new Date(membershipData?.nextPaymentDate),
//                 'MMM dd, yyyy'
//               )}
//             </p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Credits Remaining</p>
//             <p className='font-semibold'>{membershipData?.credits}</p>
//           </div>
//           <div>
//             <p className='text-gray-600'>Current Period Ends</p>
//             <p className='font-semibold'>
//               {format(
//                 new Date(membershipData?.currentPeriodEnd),
//                 'MMM dd, yyyy'
//               )}
//             </p>
//           </div>
//         </div>

//         <div className='mt-8 flex justify-between'>
//           <Link
//             to={`/restaurant/${restaurantId}/membership/upgrade`}
//             className='bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600'
//           >
//             Change Plan
//           </Link>
//           {!membershipData?.cancelledAt && (
//             <button
//               onClick={() => setShowCancelDialog(true)}
//               className='bg-red-500 text-white px-6 py-2 rounded-lg hover:bg-red-600'
//             >
//               Cancel Membership
//             </button>
//           )}
//         </div>
//       </div>

//       {/* Transaction History Section */}
//       <div className='bg-white rounded-lg shadow-md p-6'>
//         <h2 className='text-2xl font-bold mb-6'>Transaction History</h2>
//         <div className='overflow-x-auto'>
//           <table className='min-w-full'>
//             <thead>
//               <tr className='bg-gray-50'>
//                 <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                   Date
//                 </th>
//                 <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                   Description
//                 </th>
//                 <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                   Amount
//                 </th>
//                 <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                   Status
//                 </th>
//                 <th className='px-6 py-3 text-left text-gray-500 font-medium'>
//                   Invoice
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               {transactions.map((transaction) => (
//                 <tr key={transaction._id} className='border-t'>
//                   <td className='px-6 py-4'>
//                     {format(new Date(transaction.date), 'MMM dd, yyyy')}
//                   </td>
//                   <td className='px-6 py-4'>{transaction.description}</td>
//                   <td className='px-6 py-4'>
//                     ${(transaction.amount / 100).toFixed(2)}
//                   </td>
//                   <td className='px-6 py-4'>
//                     <span
//                       className={`px-2 py-1 rounded-full text-sm ${
//                         transaction.status === 'completed'
//                           ? 'bg-green-100 text-green-800'
//                           : 'bg-red-100 text-red-800'
//                       }`}
//                     >
//                       {transaction.status}
//                     </span>
//                   </td>
//                   <td className='px-6 py-4'>
//                     <a
//                       href={`/api/invoices/${transaction._id}`}
//                       target='_blank'
//                       rel='noopener noreferrer'
//                       className='text-blue-500 hover:text-blue-700'
//                     >
//                       View Invoice
//                     </a>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <div className='mt-6'>
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={(page) => fetchTransactions(page)}
//           />
//         </div>
//       </div>

//       <ConfirmationDialog
//         isOpen={showCancelDialog}
//         onClose={() => setShowCancelDialog(false)}
//         onConfirm={handleCancelMembership}
//         title='Cancel Membership'
//         message='Are you sure you want to cancel your membership? This will take effect at the end of your current billing period.'
//       />
//     </div>
//   );
// };

// export default MembershipInfo;
